"use strict";
!function (d, w, shop) {

  //{%- assign sorted_properties = "Sphere|BaseCurve|Cylinder|Axis|Addition|LenseColor|MultiFocalType|Toric|Multifocal|Colored|DryEyes|HardLense|EffectLense|LensDiameter|ContactLenseType|ContactLenseMaterial|WaterContent|ContactLensAvailability|Recommendations" | split: '|' -%}
  var cartItems = [];
  var quantityItemsKeys = [];
  var samePropertiesCounter = 0;
  var quantityItemsOrderLimit = [];
  const lensProperties = ["Sphere", "BaseCurve", "Cylinder", "Axis", "Addition", "LenseColor", "MultiFocalType", "Toric", "Multifocal", "Colored", "DryEyes", "HardLense", "EffectLense", "LensDiameter", "ContactLenseType", "ContactLenseMaterial", "WaterContent", "ContactLensAvailability", "Recommendations"];
  
  function getStockOtherLineWithSameProperties(currentItem, lineKey) {
    var stockTotal = currentItem.quantity;
   
    if (cartItems.length > 0 && currentItem.properties && Object.keys(currentItem.properties).length > 0) {
      cartItems.forEach(function (i, k) {
        var itemsKey = k + 1;
        
        if (parseInt(i.variant_id) == parseInt(currentItem.variant_id) && lineKey != itemsKey && i.properties && Object.keys(i.properties).length > 0) {
          // console.log("has SAME VARIANT");
          // console.log("current item quantity");
          // console.log(currentItem.quantity);
          // console.log("other item quantity");
          // console.log(i.quantity);
          // console.log("itemsKey= " + itemsKey);
          // console.log("lineKey = " + lineKey);
          // console.log("currentItem.variant_id");
          // console.log(currentItem.variant_id);
          // console.log("i.variant_id");
          // console.log(i.variant_id);
          // console.log("currentItem.properties");
          // console.log(currentItem.properties);
          // console.log("i.properties");
          // console.log(i.properties);
          
          var hasSameProperties = false;
          var isNotSame = false;
          for (var key in currentItem.properties) {
            var propertieName = key;
            var normalizedPropertyName = propertieName.charAt(0) === '_' ? propertieName.substring(1) : propertieName;
            var isValidProperties = false;
            lensProperties.forEach(function(prop, propKey) {
              if (prop == normalizedPropertyName) {
                isValidProperties = true;
              }
            });
            
            var comparePropertyName = i.properties.hasOwnProperty(propertieName)
              ? propertieName
              : (i.properties.hasOwnProperty('_' + normalizedPropertyName) ? '_' + normalizedPropertyName : normalizedPropertyName);

            if (isValidProperties && i.properties.hasOwnProperty(comparePropertyName)) {
              // console.log("i.properties[propertieName]");
              // console.log(i.properties[propertieName]);
              // console.log(typeof i.properties[propertieName]);
              // console.log("currentItem.properties[propertieName");
              // console.log(currentItem.properties[propertieName]);
              // console.log(typeof currentItem.properties[propertieName]);
              if (i.properties[comparePropertyName] == currentItem.properties[propertieName]) {
                //console.log("TRUE");
                hasSameProperties = true;
              } else {
                //console.log("FALSE");
                isNotSame = true;
              }
              
            }
          }

          if (hasSameProperties && isNotSame == false) {
            console.log("SAME PROPERTIES!!!");
            stockTotal = stockTotal + parseInt(i.quantity);
            console.log(stockTotal);
            var itemKey = "#" + currentItem.key + "#" + i.key + "#";
            quantityItemsKeys.push({ itemKey, stockTotal });
            samePropertiesCounter = samePropertiesCounter + 1;
            if (d.querySelector("[data-cart-item=\"" + currentItem.key + "\"]")) {
              //console.log("add data-same-properties-index");
              d.querySelector("[data-cart-item=\"" + currentItem.key + "\"]").setAttribute("data-same-properties-index", samePropertiesCounter);
            }
            if (d.querySelector("[data-cart-item=\"" + i.key + "\"]")) {
              //console.log("add data-same-properties-index");
              d.querySelector("[data-cart-item=\"" + i.key + "\"]").setAttribute("data-same-properties-index", samePropertiesCounter);
            }
          }
        }

      });
    }
    return stockTotal;
  }

  function checkOrderLimit(currentItem, lineKey) {
    console.log("checkOrderLimit");
    //console.log(currentItem);
    var orderLimit;
    var quantity = currentItem.quantity;
    //console.log(currentItem.variant_id);
    if (d.querySelector("[data-variant-id=\"" + currentItem.variant_id + "\"]").hasAttribute("data-order-limit")) {
      orderLimit = parseInt(d.querySelector("[data-variant-id=\"" + currentItem.variant_id + "\"]").getAttribute("data-order-limit"));
    }
    if (parseInt(orderLimit) <= 0) {
      return;
    }
    console.log("orderLimit= " + orderLimit);
    
    if (d.querySelectorAll("[data-variant-id=\"" + currentItem.variant_id + "\"][data-quantity-input-desktop]").length > 0) {
      var totalQuantitySameVariantID = 0;
      d.querySelectorAll("[data-variant-id=\"" + currentItem.variant_id + "\"][data-quantity-input-desktop]").forEach(function (element, key) {
        console.log("element with same variant id");
        // console.log(element);
        // console.log(element.value);
        totalQuantitySameVariantID = totalQuantitySameVariantID + parseInt(element.value);
      });
    }

    if (totalQuantitySameVariantID && quantityItemsOrderLimit && quantityItemsOrderLimit.length > 0) {
      var isFoundVariantID = false;
      quantityItemsOrderLimit.forEach(function (quantityItem, k) {
        if (quantityItem.hasOwnProperty("ItemVariantID") && quantityItem["ItemVariantID"] == currentItem.variant_id) {
          console.log("SET new quantity for totalQuantitySameVariantID");
          totalQuantitySameVariantID = (parseInt(quantityItem["totalNew"]) < 0 ? 0 : parseInt(quantityItem["totalNew"]));
        }
      });
    }

    console.log("totalQuantitySameVariantID");
    console.log(totalQuantitySameVariantID);
    console.log("orderLimit= " + orderLimit);
  
    if ((totalQuantitySameVariantID && orderLimit < totalQuantitySameVariantID) || quantity > orderLimit) {
      
      if (totalQuantitySameVariantID && orderLimit < totalQuantitySameVariantID) {
       
        var diffTotal = totalQuantitySameVariantID - currentItem.quantity;
        console.log("totalQuantitySameVariantID");
        console.log("diffTotal");
        console.log(diffTotal);
        console.log("quantityItemsOrderLimit");
        console.log(quantityItemsOrderLimit);
        if (quantityItemsOrderLimit && quantityItemsOrderLimit.length > 0) {
          var isFound = false;
          quantityItemsOrderLimit.forEach(function (quantityItem, k) {
            if (quantityItem.hasOwnProperty("ItemVariantID") && quantityItem["ItemVariantID"] == currentItem.variant_id) {
              quantityItem["totalNew"] = diffTotal;
              isFound = true;
            }
          });

          if (isFound == false) {
            quantityItemsOrderLimit.push({ ItemVariantID: currentItem.variant_id, totalNew: diffTotal });
          }

        } else {
          quantityItemsOrderLimit.push({ ItemVariantID: currentItem.variant_id, totalNew: diffTotal });
        }
      }

      console.log("CHANGE CART QUANTITY");

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({quantity: 0, line: lineKey}),
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      }).then(function (data) {
        w.location.reload();
      }).catch(function (error) {
        console.warn(error);
        d.querySelector(".loaderElement").remove();
      });
    }

  }

  function checkStock(lineItem, lineKey, lineOrderLimit) {
    var lineItem = lineItem || null;
    var lineKey = lineKey || null;
    var lineOrderLimit = lineOrderLimit || null;
    var variantID = lineItem.variant_id;
    
    if (lineItem.product_type && lineItem.product_type == "care") {
      checkOrderLimit(lineItem, lineKey);
    }

    if (lineItem.product_type && lineItem.product_type != "lens") {
      return;
    }

    let correctionValues = {};
    if (lineItem.properties) {
      Object.keys(lineItem.properties).forEach(function(key) {
        var normalizedKey = key.charAt(0) === '_' ? key.substring(1) : key;
        correctionValues[normalizedKey] = lineItem.properties[key];
      });
    }

    let lensData = {
      "shop_domain": shop.shop,
      "shopify_id": variantID,
      "correctionValues": correctionValues
    }

    let api_base = shop.theme.settings.api_base_url,
        id = variantID,
        stockAPI = `${api_base}/api/v1/stock/${id}/bundle`;
    fetch(stockAPI, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(lensData)
    }).then(function (response) {
      if (response.ok) { return response.json(); }
      return Promise.reject(response);
    })
    .then(function(data){
      
      if (d.querySelectorAll("[data-cart-item=\"" + lineItem.key + "\"] [data-max-stock]").length > 0) {
        d.querySelectorAll("[data-cart-item=\"" + lineItem.key + "\"] [data-max-stock]").forEach(function(element){
            element.setAttribute("data-max-stock", data.stock);
        });
      }
      var totalStock = lineItem.quantity;
      var totalStockWithSameProperties = getStockOtherLineWithSameProperties(lineItem, lineKey);
      if (totalStockWithSameProperties && totalStockWithSameProperties > 0) {
        totalStock = totalStockWithSameProperties
      }
      if (quantityItemsKeys.length > 0) {
        quantityItemsKeys.forEach(function(itemKey, k) {
          var isLoopOnce = false;
          if (!isLoopOnce && itemKey.hasOwnProperty("diffStockTotal") && itemKey.hasOwnProperty("itemKey") && itemKey["itemKey"].includes(lineItem.key)) {
            totalStock = totalStock - itemKey["diffStockTotal"];
            isLoopOnce = true;
          }
        });
      }

      console.log("RESULT totalStock Before");
      console.log(totalStock);
      
      if (data.available && data.always_available == false && data.stock < totalStock || lineOrderLimit > 0 && lineOrderLimit < lineItem.quantity) {
        
        var changeQuantity;
        var diffTotalStock = 0;

        // check has orderLimit exist
        var orderLimitQuantityChange;
        if (lineOrderLimit > 0 && lineOrderLimit < totalStock) {
          changeQuantity = orderLimitQuantityChange = lineOrderLimit;
        }
        // check has maxstock exist
        var maxStockQuantityChange;
        if (parseInt(data.stock) < totalStock) {

          if ((parseInt(data.stock) - totalStock) <= 0) {
            changeQuantity = maxStockQuantityChange = 0;
            diffTotalStock = totalStock - lineItem.quantity;
          } else {
            changeQuantity = maxStockQuantityChange = (parseInt(data.stock) < 0 ? 0 : parseInt(data.stock));
            diffTotalStock = totalStock - changeQuantity;
          }

        }
        // check has maxstock and orderLimit exist
        if (maxStockQuantityChange && orderLimitQuantityChange) {
          changeQuantity = orderLimitQuantityChange;
          if (maxStockQuantityChange <= orderLimitQuantityChange) {
            changeQuantity = maxStockQuantityChange;
          }
        }
        if (quantityItemsKeys.length > 0) {
          quantityItemsKeys.forEach(function(itemKey, k) {
            if (itemKey.hasOwnProperty("itemKey") && itemKey["itemKey"].includes(lineItem.key)) {
              itemKey["diffStockTotal"] = diffTotalStock;
            }
          });
        }
        console.log("CHANGE CART QUANTITY");
        console.log(changeQuantity);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({quantity: changeQuantity, line: lineKey}),
        }).then(function (response) {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response);
        }).then(function (data) {
          w.location.reload();
        }).catch(function (error) {
          console.warn(error);
          d.querySelector(".loaderElement").remove();
        });

      }
    }).catch(function (error) {
      // if(!(/(?:-dev|43025203365.shopifypreview)/ig).test(w.location.hostname)) {
      //   console.warn('Something went wrong:', error);
      //   return false;
      // }
      let fake = {
        shopify_id: id,
        available: true,
        always_available: false,
        stock: 0
      };
    });
  };

  fetch('/cart.js').then(function (response) {
      // The API call was successful!
      return response.json();
  }).then(function (dataResponse) {
    
    if (dataResponse.items.length > 0) {
      let deliveryTime = "Levering 2 – 3 arbeidsdager"; 
      cartItems = dataResponse.items;

      dataResponse.items.forEach(function (item, key) {
        var lineKey = key + 1;
        if (item.properties && (item.properties._quantity_property || item.properties.quantity_property) === "Levering 5 – 9 arbeidsdager") {
          deliveryTime = "Levering 5 – 9 arbeidsdager";
        }
        var lineItemsFields = d.querySelectorAll("[data-cart-item-order-limit]");
        var orderLimitQuantity = 0;
        if (lineItemsFields.length > 0 ) {
          function isNumeric(num){
            return !isNaN(num)
          }
          lineItemsFields.forEach(function(itemElement, itemKey){
            itemKey++;
            var orderLimitItem = itemElement.getAttribute('data-cart-item-order-limit');
            if (itemKey == lineKey && isNumeric(orderLimitItem) && parseInt(orderLimitItem) < item.quantity) {
              orderLimitQuantity = orderLimitItem;
            }
          });
        }
        checkStock(item, lineKey, orderLimitQuantity);
      
        // if (item.properties.maxStock && item.properties.alwaysAvailable != "alwaysAvailable" && parseInt(item.properties.maxStock) < item.quantity || orderLimitQuantity > 0 && orderLimitQuantity < item.quantity) {
        //     console.log("CHANGE CART");
        //     let loaderElement = d.createElement("div");
        //     loaderElement.className = "loaderElement";
        //     d.body.appendChild(loaderElement);

        //     var changeQuantity;

        //     // check has orderLimit exist
        //     var orderLimitQuantityChange;
        //     if (orderLimitQuantity > 0 && orderLimitQuantity < item.quantity) {
        //       changeQuantity = orderLimitQuantityChange = orderLimitQuantity;
        //     }
        //     // check has maxstock exist
        //     var maxStockQuantityChange;
        //     if (item.properties.maxStock && item.properties.alwaysAvailable != "alwaysAvailable" && parseInt(item.properties.maxStock) < item.quantity) {
        //       changeQuantity = maxStockQuantityChange = (parseInt(item.properties.maxStock) < 0 ? 0 : parseInt(item.properties.maxStock));
        //     }
            
        //     // check has maxstock and orderLimit exist
        //     if (maxStockQuantityChange && orderLimitQuantityChange) {
              
        //       changeQuantity = orderLimitQuantityChange;
        //       if (maxStockQuantityChange <= orderLimitQuantityChange) {
        //         changeQuantity = maxStockQuantityChange;
        //       }
        //     }
        //     console.log("result changeQuantity");
        //     console.log(changeQuantity);
        //     fetch('/cart/change.js', {
        //       method: 'POST',
        //       headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //       },
        //       body: JSON.stringify({quantity: changeQuantity, line: lineKey}),
        //     }).then(function (response) {
        //       if (response.ok) {
        //         return response.json();
        //       }
        //       return Promise.reject(response);
        //     }).then(function (data) {
        //       w.location.reload();
        //     }).catch(function (error) {
        //       console.warn(error);
        //       d.querySelector(".loaderElement").remove();
        //     });
        // }
      
      });
      document.querySelector(".append_data_from_localstorage").textContent = deliveryTime;
    }
  }).catch(function (err) {
    // There was an error
    console.warn('Something went wrong.', err);
  });
 
}(document, window, Shopify);
